import type React from 'react';
import { createContext, useContext } from 'react';

interface PanelContextProps {
  isPopout: boolean;
}

const PanelContext = createContext<PanelContextProps>({ isPopout: false });

export const PanelContextProvider = ({ children, value }: { children: React.ReactNode; value: PanelContextProps }) => {
  return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>;
};

export const usePanelContext = (): PanelContextProps => {
  return useContext(PanelContext);
};
